import React from "react";
import { Button, Modal } from "react-bootstrap";

const LargeModal = (props) => {

  return (
    <Modal show={props.show} onHide={props.handleClose} className='large-modal'>
      <Modal.Header closeButton>
        <Modal.Title className='text-success'>{props.Title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{props.message}</p>
        <div className='image'>
          <img src={props.projectData.ImgUrl} alt='' />
          {props.projectData?.flag && <span>{props.projectData?.flag}</span>}
        </div>
        <a href={props.projectData.demo} target='_blank' rel='noreferrer'>
          Go to The Site
        </a>
      </Modal.Body>
      <Modal.Footer className='justify-content-center'>
        <Button variant='secondary' onClick={props.handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LargeModal;
